module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/logo_2-c0e9198a2ac4a66dcfcb7a96da339e13.svg";